import React, { useState } from "react";
import "../../styles/admins/inventory.css";
import axios from "axios";

function AddCompany(props) {
  const [formData, setFormData] = useState({
    comp_name: props.editComp.company_name || "",
    comp_id: props.editComp.comp_id || "",
    location: props.editComp.location || "",
    contact: props.editComp.contact || "",
    email: props.editComp.email || "",
    image: props.editComp.image || null,
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle file upload
  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      image: e.target.files[0],
    }));
  };

  // Submit form data
  const handleSubmit = async (e) => {
    e.preventDefault();
    props.handleLoading();

    const formDataToSend = new FormData();
    formDataToSend.append("comp_name", formData.comp_name);
    formDataToSend.append("comp_id", formData.comp_id);
    formDataToSend.append("location", formData.location);
    formDataToSend.append("contact", formData.contact);
    formDataToSend.append("email", formData.email);
    if (formData.image) {
      formDataToSend.append("image", formData.image);
    }

    try {
      if (Object.keys(props.editComp).length === 0) {
        await axios.post(
          "https://api.dectwinservices.com/api/add-company",
          formDataToSend,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        props.handleToast({
          toastMsg: "Company Added Successfully!!!",
          toastColor: "#4CAF50",
        });
      } else {
        await axios.put(
          `https://api.dectwinservices.com/api/update-company`,
          formDataToSend
        );
        props.handleToast({
          toastMsg: "Company Updated Successfully!!!",
          toastColor: "#4CAF50",
        });
      }
      localStorage.removeItem("companies");
      window.location.reload();
    } catch (error) {
      props.handleToast({
        toastMsg: "Something went wrong! Please check data or internet.",
        toastColor: "#FF0000",
      });
    }
    props.closeLoading();
  };

  return (
     <section className="px-3">
      <div className="d-md-flex justify-between my-3">
        <div className="d-flex">
          <i className="bx bxs-plus-circle" style={{ fontSize: "24px" }}></i>
          <p className="fw-bolder fs-big">
            &nbsp;
            {Object.keys(props.editComp).length === 0
              ? "Add New Company"
              : `Edit Company "${props.editComp.company_name}"`}
          </p>
        </div>
        <button className="add-btn" onClick={props.toggler}>
          <i
            className="bx bxs-left-arrow-circle"
            style={{ fontSize: "22px" }}
          ></i>
          &nbsp; View Companies
        </button>
      </div>

      <div className="p-3 bg-white" >

          {props.editComp.image &&
<div style={{textAlign: 'center'}}>
<img src={`https://api.dectwinservices.com/${props.editComp.image}`} style={{height: '8em', borderRadius: '50%', marginTop: '1em',
  border: '3px solid var(--gray)'
}} alt="company" /></div> }


        <form
          className="row"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
        >
          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="comp_name">Company Name</label>
            <div className="input-icon">
              <i className="bx bxs-layer"></i>
              <input
                type="text"
                name="comp_name"
                id="comp_name"
                value={formData.comp_name}
                onChange={handleChange}
                placeholder="Company Name"
                required
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="comp_id">Company ID</label>
            <div className="input-icon">
              <i className="bx bx-id-card"></i>
              <input
                type="text"
                name="comp_id"
                id="comp_id"
                value={formData.comp_id}
                onChange={handleChange}
                placeholder="Company ID"
                required
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="location">Company Location</label>
            <div className="input-icon">
              <i className="bx bx-map"></i>
              <input
                type="text"
                name="location"
                id="location"
                placeholder="Company Location"
                value={formData.location}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="contact">Company Contact</label>
            <div className="input-icon">
              <i className="bx bx-phone"></i>
              <input
                type="text"
                name="contact"
                id="contact"
                placeholder="Company Contact"
                value={formData.contact}
                onChange={handleChange}
                pattern="[0-9]*"
  maxLength={10}
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="email">Company Email</label>
            <div className="input-icon">
              <i className="bx bx-envelope"></i>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Company Email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          </div>

            <div className="form-data col-lg-4 col-md-6 col-12">
              <label htmlFor="image">Upload Logo</label>
              <div className="input-icon">
                <i className="bx bxs-image"></i>
                <input
                  type="file"
                  name="image"
                  id="image"
                  onChange={handleFileChange}
                  accept="image/*"
                />
              </div>
            </div>

            
          {/* {props.editComp.image ? (
            <div className="form-data col-lg-4 col-md-6 col-12">
              <label htmlFor="comp_name">Logo Uploaded</label>
              <div className="input-icon">
                <i className="bx bxs-image"></i>
                <input
                  type="text"
                  name="image"
                  id="image"
                  value={formData.image}
                  disabled
                />
              </div>
            </div>
          ) : (
            <div className="form-data col-lg-4 col-md-6 col-12">
              <label htmlFor="image">Upload Logo</label>
              <div className="input-icon">
                <i className="bx bxs-image"></i>
                <input
                  type="file"
                  name="image"
                  id="image"
                  onChange={handleFileChange}
                  accept="image/*"
                />
              </div>
            </div>
          )} */}

          {/* <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="technician_id">Select Technician</label>
            <div className="input-icon">
              <i className="bx bxs-user"></i>
              <select
                name="technician_id"
                id="technician_id"
                value={formData.technician_id}
                onChange={handleChange}
                // required
              >
                <option value="">Select Technician</option>
                {technicians.map((tech) => (
                  <option key={tech.id} value={tech.id}>
                    {tech.name}
                  </option>
                ))}
              </select>
            </div>
          </div> */}


                    <div className="btn-group d-flex mt-2" style={{ justifyContent: "end" }}>

<button type="submit" className="button-85">
            Submit
          </button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default AddCompany;
